"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.monospace = exports.linkActive = exports.link = exports.text = exports.subtitle = exports.title = exports.h3 = exports.h2 = exports.h1 = exports.primaryFont = void 0;

var _dims = require("./dims");

var _colors = require("./colors");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var primaryFont = {
  fontWeight: '300',
  lineHeight: '1.3',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  color: _colors.grey5
};
exports.primaryFont = primaryFont;

var h1 = _extends({}, primaryFont, {
  fontSize: 23,
  fontWeight: '500'
});

exports.h1 = h1;

var h2 = _extends({}, primaryFont, {
  fontSize: 20,
  fontWeight: '500'
});

exports.h2 = h2;

var h3 = _extends({}, primaryFont, {
  fontSize: 18,
  fontWeight: '500'
});

exports.h3 = h3;

var title = _extends({}, primaryFont, {
  fontWeight: '500',
  fontSize: 16
});

exports.title = title;

var subtitle = _extends({}, primaryFont, {
  fontWeight: '500',
  fontSize: 14
});

exports.subtitle = subtitle;

var text = _extends({}, primaryFont, {
  fontSize: 14
});

exports.text = text;

var link = _extends({}, primaryFont, {
  fontSize: 14
});

exports.link = link;

var linkActive = _extends({}, primaryFont, link);

exports.linkActive = linkActive;

var monospace = _extends({}, primaryFont, {
  fontFamily: 'monospace'
});

exports.monospace = monospace;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-core/styles/fonts.js
// module id = ./node_modules/quark-core/styles/fonts.js
// module chunks = 0